import { render, staticRenderFns } from "./CinemasDetails.vue?vue&type=template&id=5d834631&scoped=true"
import script from "./CinemasDetails.vue?vue&type=script&lang=js"
export * from "./CinemasDetails.vue?vue&type=script&lang=js"
import style0 from "./CinemasDetails.vue?vue&type=style&index=0&id=5d834631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d834631",
  null
  
)

export default component.exports